module.exports = __webpack_public_path__ + "img/Operatore.994c8121.svg";